// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5084":"f1ab9015","9032":"ef8d8f94"}[chunkId] + ".chunk.css";
};